if (!customElements.get('video-hero')) {
  class VideoHero extends HTMLElement {
    connectedCallback() {
      this.video =
        this.querySelector("video") ||
        (this.tagName === "VIDEO" ? this : null);

      if (!this.video) return;

      // Ensure attributes/properties Safari cares about are set immediately
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.setAttribute("muted", "");
      this.video.setAttribute("playsinline", "");
      this.video.setAttribute("webkit-playsinline", "");
      this.video.setAttribute("autoplay", "");
      if (!this.video.hasAttribute("preload")) this.video.setAttribute("preload", "auto");

      this._tryPlay = async () => {
        // If the video isn't ready yet, play() will throw; that's fine.
        try {
          await this.video.play();
        } catch (e) {}
      };

      // Try as soon as Safari has enough info, plus a user-gesture fallback.
      this.video.addEventListener("loadedmetadata", this._tryPlay, { once: true });
      this.video.addEventListener("canplay", this._tryPlay, { once: true });

      // iOS Safari sometimes requires a gesture even when muted.
      this._unlock = () => this._tryPlay();
      window.addEventListener("touchstart", this._unlock, { once: true, passive: true });
      window.addEventListener("click", this._unlock, { once: true, passive: true });

      // Attempt immediately too (works on desktop Safari / some iOS cases)
      this._tryPlay();
    }

    disconnectedCallback() {
      if (this._unlock) {
        window.removeEventListener("touchstart", this._unlock);
        window.removeEventListener("click", this._unlock);
      }
    }
  }

  customElements.define('video-hero', VideoHero);
}